/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { usePodcastStore } from '../store/usePodcastStore';
import PageHighlight from '@/components/PageHighlight';

export default function Highlight() {
  const { page } = usePodcastStore();

  if (!page?.page) {
    return null;
  }

  return (
    <PageHighlight
      title={page?.page?.intro?.title}
      description={page?.page?.intro?.description}
      thumbnail={page?.page?.intro?.thumbnail}
    />
  );
}
